import {ErrorHandler, ModuleWithProviders, NgModule} from '@angular/core';
import {Config} from './const/config';
import {EIntercepterService} from './eintercepter.service';
import {EHandlerService} from './ehandler.service';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HookService} from './hook.service';

export const InitialConfig: Config = {
  message: {
    unAuthenticated: 'XahiÅ olunur sistemÉ daxil olun!',
    statusException: 'Status xÉtasÄ±',
    serverException: 'Server xÉtasÄ±',
    appException: 'Sistem xÉtasÄ±'
  },
  logout: '/logout',
  logoutCodes: [
    401,  // Bu Ã¼nvana icazÉniz yoxdur
    1005, // You are not allowed to request this resource
    1006, // Token tapÄ±lmadÄ±
    1014, // Token tapÄ±lmadÄ±, zÉhmÉt olmasa sistemÉ yenidÉn daxil olun
    1015, // Sizin sistemlÉrdÉn istifÉdÉ hÃ¼ququnuz yoxdur
    1016, // Sizin bu sistemÉ istifÉdÉ hÃ¼ququnuz yoxdur
    1017, // Sessiya baÄlanmÄ±ÅdÄ±r, zÉhmÉt olmasa sistemÉ yenidÉn daxil olun.
    1401, // Sessiya mÃ¼ddÉti bitmiÅdir, zÉhmÉt olmazsa sistemÉ yenidÉn daxil olun
    // 1402  // Sizin bu servisÉ icazÉniz yoxdur
  ],
  hook: 'https://hooks.slack.com/services/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',
}

@NgModule({
  imports: [
    HttpClientModule,
    BrowserAnimationsModule
  ],
  providers: [
    { provide: ErrorHandler, useClass: EHandlerService },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EIntercepterService,
      multi: true
    },
    HookService
  ],
  declarations: [],
  exports: []
})
export class EHandlerModule {
  static forRoot(configurations = InitialConfig): ModuleWithProviders {
    return {
      ngModule: EHandlerModule,
      providers: [
        {provide: 'configurations', useValue: configurations},
      ],
    };
  }
  static forChild(): ModuleWithProviders {

    return{
      ngModule: EHandlerModule,
    };

  }

}
